
import {React, useState, useContext, useEffect, useRef} from "react"
import { Link } from "react-router-dom"
import{UserContext} from '../../context/userContext/userContext'
import { useStyle } from '../../context/styleContext/styleContext';
import ReactGA from 'react-ga4';



export default function About(){

  const { user } = useContext(UserContext);
  const { isLoading } = useContext(UserContext);
  const { style, setStyle } = useStyle();

    ReactGA.send({
      hitType:"pageview",
      page:"about",
      title:"about",
    })

    useEffect(() => {
      document.title = 'Parish Audio | Cutting-Edge Audio Processing | About';
  }, []);

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);
    



    return(
        <>
        <div style={{backgroundImage: `url("/RecordingStudioStockImage1.jpg")`, backgroundSize: "cover", backgroundPosition: "center"}}>
        <div style={{flex:1, backgroundColor:'rgba(0,0,0,.7'}}>
        <div ref={topContainer} style={{display:'flex', flexDirection:'column', width:'95%', maxWidth:'600px', minHeight:height - 130, margin:'auto'}}>
          <div style={{textAlign:'left', color: style.color4,}}>
            <h1 style={{ marginTop:'50px', marginBottom:'50px', textAlign:'center'}}> About</h1>
            <p>
                Hey everyone! I have put this site together to offer some of the audio plugins I have created for my own personal projects. Currently most of them are in a beta version, so for now I am offering them for free. Go ahead and try out anything you like. I would appreciate any feedback you would like to provide, as well as any bugs/issues you encounter.</p>
                <p> Please send any feedback to  <a href="mailto:support@parishaudio.com" style={{color:style.color2, fontSize:'12pt'}}><strong>support@parishaudio.com</strong></a>. Thanks!   

            </p>
            <p>-Nate</p>
            </div>
            </div>
          </div>
          </div>
        </>

    )
}